import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  setIsLoadingSummary: false,
  appointment: {},
  service: { uuid: null, name: null, price: { amount: null, localized: null } },
  summary: { total: null, localized: null },
  selectedTip: {},
  customTip: null,
  customDiscount: {
    value: '',
    type: '%',
  },
  // Mix of complete (name && price) add-ons and custom items
  completeItems: [],
  // Mix of incomplete (!name || !price) add-ons and custom items
  incompleteItems: [],
  customItems: [],
};

const checkout = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    setAppointment(state, { payload }) {
      state.appointment = payload;
    },
    setService(state, { payload }) {
      state.service = payload;
    },
    setSummary(state, { payload }) {
      state.summary = payload;
    },
    setTip(state, { payload }) {
      state.selectedTip = payload;
    },
    setCustomTip(state, { payload }) {
      state.customTip = payload;
    },
    setCustomDiscount(state, { payload }) {
      state.customDiscount = payload;
    },
    setCompleteItems(state, { payload }) {
      state.completeItems = payload;
    },
    setIncompleteItems(state, { payload }) {
      state.incompleteItems = payload;
    },
    setIsLoadingSummary(state, { payload }) {
      state.setIsLoadingSummary = payload;
    },
    setCustomItems(state, { payload }) {
      state.customItems = payload;
    },
    clearCheckoutForm(state) {
      return initialState;
    },
  },
});

const { actions, reducer } = checkout;

export const {
  setAppointment,
  setService,
  setSummary,
  setTip,
  setCustomTip,
  setCustomDiscount,
  setCompleteItems,
  setIncompleteItems,
  setIsLoadingSummary,
  setCustomItems,
  clearCheckoutForm,
} = actions;

export default reducer;
